import request from '@/utils/request'

// 注册用户
export function registerPhoneNumber(data) {
    return request({
        url: `/user/edu/cloud/v3/register/user/by/phoneNumber`,
        method: 'post',
        data:data
    })
}
//获取注册短信验证码
export function registerCaptcha(data) {
    return request({
        url: `/user/edu/cloud/v3/send/register/sms/captcha`,
        method: 'post',
        data:data
    })
}
//手机号码登录
export function loginPhoneNumber(data) {
    return request({
        url: `/user/edu/cloud/v3/login/user/by/phoneNumber`,
        method: 'post',
        data:data
    })
}
//获取登录短信验证码
export function loginCaptcha(data) {
    return request({
        url: `/user/edu/cloud/v3/send/login/sms/captcha`,
        method: 'post',
        data:data
    })
}
//获取个人信息-全角色(教育云平台-个人信息)
export function personalInfo(data) {
    return request({
        url: `/user/edu/cloud/get/personal/info`,
        method: 'post',
        data:data
    })
}
//获取登录账号菜单按钮(云平台-菜单权限)
export function getmenu(pfId) {
    return request({
        url: `/user/edu/cloud/get/my/menu?pfId=${pfId}`,
        method: 'post',
    })
}


// WEBPACK FOOTER //
// ./src/api/register.js